import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export interface EnviromentVariables {
  API_URL: string;
}

export const env: EnviromentVariables = publicRuntimeConfig;
